import React from 'react';
import './Empleo.css';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { FaFileAlt, FaCalendarAlt, FaBriefcase } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import escudo from '../../Images/Escudo.png';

const Empleo = () => {
  const navigate = useNavigate();
  const empleos = [
    {
      id: 1,
      titulo: "Bolsa de Trabajo – Auxiliar de Ayuda a Domicilio",
      descripcion: "Proceso selectivo con puntuaciones provisionales publicadas. Consulta el acta de puntuaciones ordenadas de mayor a menor y el plazo para alegaciones.",
      activo: false,
      enSeleccion: true,
      puntuacionesPublicadas: true,
      fechaPublicacion: "Octubre 2025",
      modalidad: "Temporal",
    }
  ];

  const handleSolicitar = (empleoId) => {
    navigate('/empleo/auxiliar-ayuda-domicilio');
  };

  return (
    <section className="empleo-section">
      <Container>
        {/* Header */}
        <div className="empleo-header">
          <h1 className="empleo-title">Portal de Empleo</h1>
          <p className="empleo-subtitle">
            Conoce las ofertas de empleo disponibles en el Ayuntamiento de Escalonilla
          </p>
        </div>


        {/* Cards de empleos */}
        <Row>
          {empleos.map((empleo) => (
            <Col lg={12} key={empleo.id} className="mb-4">
              <Card className="empleo-card">
                <Card.Body>
                  <Row className="align-items-center">
                    <Col md={2} className="text-center mb-3 mb-md-0">
                      <div className="escudo-container">
                        <img src={escudo} alt="Escudo Ayuntamiento" className="escudo-empleo" />
                      </div>
                    </Col>
                    
                    <Col md={8}>
                      <div className="empleo-info">
                        <div className="empleo-header-card">
                          <h3 className="empleo-nombre">{empleo.titulo}</h3>
                          {empleo.activo && (
                            <Badge bg="success" className="estado-badge">
                              ACTIVO
                            </Badge>
                          )}
                          {empleo.enSeleccion && empleo.puntuacionesPublicadas && (
                            <Badge bg="success" className="estado-badge">
                              ACTA DEFINITIVA PUBLICADA
                            </Badge>
                          )}
                          {empleo.enSeleccion && !empleo.puntuacionesPublicadas && (
                            <Badge bg="warning" className="estado-badge">
                              EN SELECCIÓN
                            </Badge>
                          )}
                        </div>
                        
                        <p className="empleo-descripcion">{empleo.descripcion}</p>
                        
                        <div className="empleo-detalles">
                          <div className="detalle-item">
                            <FaCalendarAlt className="detalle-icon" />
                            <span>Publicado: {empleo.fechaPublicacion}</span>
                          </div>
                          <div className="detalle-item">
                            <FaBriefcase className="detalle-icon" />
                            <span>Modalidad: {empleo.modalidad}</span>
                          </div>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md={2} className="text-center">
                      <Button 
                        variant={empleo.puntuacionesPublicadas ? "success" : empleo.enSeleccion ? "warning" : "primary"}
                        size="lg" 
                        className="btn-solicitar text-white"
                        onClick={() => handleSolicitar(empleo.id)}
                        disabled={!empleo.activo && !empleo.enSeleccion}
                      >
                        <FaFileAlt className="me-2" />
                        {empleo.puntuacionesPublicadas ? "Ver Resolución" : empleo.enSeleccion ? "Ver Resultados" : "Solicitar"}
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Empleo;
